import React, { useState } from 'react';
import { useFilters } from '../../contexts/FilterContext';
import Drawer from '../common/Drawer';
import './FilterModal.css';

const FilterModal = () => {
  const { isFilterModalOpen, closeFilterModal, applyFilters, clearFilters, selectedFlavor, dateRange } = useFilters();
  const [flavor, setFlavor] = useState(selectedFlavor);
  const [dates, setDates] = useState(dateRange);
  // Escape, click-outside and the scroll lock are handled by <Drawer>.

  if (!isFilterModalOpen) {
    return null;
  }

  const handleApply = () => {
    applyFilters({ flavor, dateRange: dates });
  };

  const handleClear = () => {
    clearFilters();
    setFlavor('all');
    setDates({ start: '', end: '' });
  };

  const getTodayDate = () => {
    return new Date().toISOString().split('T')[0];
  };

  const footer = (
    <>
      <button className="app-drawer-btn app-drawer-btn--secondary" onClick={handleClear}>Reset</button>
      <button className="app-drawer-btn app-drawer-btn--primary" onClick={handleApply}>Apply</button>
    </>
  );

  return (
    <Drawer isOpen onClose={closeFilterModal} title="Global Filters" footer={footer}>
      <div id="global-filter-panel">
          <div className="filter-group">
            <label htmlFor="flavor-filter">Flavor Filter</label>
            <select 
              id="flavor-filter" 
              className="filter-select"
              value={flavor} 
              onChange={(e) => setFlavor(e.target.value)}
            >
              <option value="all">All Flavors</option>
              <option value="vanilla">Vanilla</option>
              <option value="chocolate">Chocolate</option>
              <option value="strawberry">Strawberry</option>
              <option value="mint">Mint</option>
              <option value="caramel">Caramel</option>
              <option value="cookies-cream">Cookies & Cream</option>
              <option value="rocky-road">Rocky Road</option>
              <option value="neapolitan">Neapolitan</option>
            </select>
            <p className="filter-help">Filter data by ice cream flavor</p>
          </div>
          <div className="filter-group">
            <label>Date Range</label>
            <div className="date-range-inputs">
              <div className="date-input-group">
                <label htmlFor="start-date">From</label>
                <input
                  type="date"
                  id="start-date"
                  className="filter-date"
                  value={dates.start}
                  onChange={(e) => setDates({ ...dates, start: e.target.value })}
                  max={dates.end || getTodayDate()}
                />
              </div>
              <div className="date-input-group">
                <label htmlFor="end-date">To</label>
                <input
                  type="date"
                  id="end-date"
                  className="filter-date"
                  value={dates.end}
                  onChange={(e) => setDates({ ...dates, end: e.target.value })}
                  min={dates.start}
                  max={getTodayDate()}
                />
              </div>
            </div>
            <p className="filter-help">Filter data by date range</p>
          </div>
      </div>
    </Drawer>
  );
};

export default FilterModal;
